import React from "react";
import Property from "./Property";

export default class SizeProperty extends Property {

  init() {
    this.state = {
      width: this.getValue().width,
      height: this.getValue().height
    }
  }

  onChange(type, value) {
    this.props.property.value[type] = parseInt(value, 10);

    let st = {};
    st[type] = value;
    this.setState(st);
  }

  render() {
    return (
      <div className="property sizeProperty">
        <div className="key">{this.getKey()}</div>
        <div className="documentSize">
          <div className="actualSize">
            <input onChange={(e) => this.onChange("width", e.target.value)} type="number" className="width" value={this.state.width}/>
            <span style={{margin: "0 4px", color: "black", fontSize: "1.1em"}}>x</span>
            <input onChange={(e) => this.onChange("height", e.target.value)} type="number" className="height" value={this.state.height}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/SizeProperty.js